module.exports = __webpack_public_path__ + "img/icon_auto.8ded26bf.png";